/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCulinaryClassTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCulinaryClass,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Cook Together!",
    "Culinary Adventure Awaits!",
    "Taste the Magic!",
  ],
  title: "Culinary Class",
  description: "Organize a fun culinary class.",
  longDescription:
    "Gather your friends for a delicious culinary class! Choose a date, decide on the cuisine, and plan the menu for the session!",
  emoji: "🍳",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Culinary Class",
          emoji: "🍳",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the culinary class?",
          emoji: "📅",
          completeAction: {
            question: "Decide on the cuisine to prepare?",
            description: "What type of cuisine should we explore?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What cuisines should we consider?",
                emoji: "🥘",
                completeAction: {
                  question: "Decide on ingredients to buy?",
                  description:
                    "What ingredients should we gather for the class?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What ingredients should we bring?",
                      emoji: "🧄",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Cooking!",
    outroDescription:
      "Your culinary class plans are set! Enjoy the delicious experience!",
  },
};
